import { Typography } from "@mui/material";
import React, { useState } from "react";
import ImageUploading from "react-images-uploading";
import CustomButton from "./custom-button-component";
import { useDispatch } from 'react-redux'
import { SetuploadImageFileName } from '../reducers/global-reducer';
import ImageCropper from "./image-cropper-component";
import { AddPhotoAlternateOutlined } from "@mui/icons-material";
import { useTranslate } from "react-redux-multilingual";
import "./image-upload-component"

export default function ImageUploadCanvas() {
  const [images, setImages] = React.useState([]);
  const [imageState, setimageState] = useState("upload")
  const dispatch = useDispatch();
  const maxNumber = 1;
  const onChange = (imageList) => {
    // data for submit
    dispatch(SetuploadImageFileName(imageList[0].file.name))
    setImages(imageList);
  };

  const t = useTranslate();
  const cropUploadedImage = () => setimageState("crop")

  return (
    <div className="image-container">
      <ImageUploading
        multiple
        value={images}
        onChange={onChange}
        maxNumber={maxNumber}
        dataURLKey="data_url"
      >
        {({
          imageList,
          onImageUpload,
          onImageRemove,
          dragProps
        }) => (
          // write your building UI
          <div className="upload-img">
            {
              // Upload image
              imageList.length === 0 ?
                <div 
                className="imagelist"
                  onClick={onImageUpload}
                  {...dragProps}
                >
                  <AddPhotoAlternateOutlined sx={{ fontSize: '70px' }} />
                  <Typography variant="h5" className="imgtypo">  {t('imageUploadMsg')}</Typography>
                </div>
                :
                imageList.map((image, index) => (
                  <>
                    <div key={index} className="image-item" >
                      <ImageCropper imageUrl={image.data_url} imageState={imageState} />

                    </div>
                    <div style={{display:"flex",marginTop:"200px"}}>
                      {/* For Remove image */}
                      <div className="imgbtn">
                        <CustomButton
                          padding="5px 13px"
                          margin='4px 0'
                          fontSize="15px"
                          color='#256EFF'
                          variant="contained"
                          // type={"submit"}
                          // handleClick={() => onImageRemove(index)}
                          handleClick={() => {
                            onImageRemove(index);
                            dispatch(SetuploadImageFileName("")); // clear filename from redux
                          }}
                        >
                          {t('imageUploadMsgRemoveBtn')}
                        </CustomButton>

                      </div>
                      <div className="imgmsgbtn">
                        {/* Crop imgae  */}
                        <CustomButton
                          padding="5px 13px"
                          margin='4px'
                          fontSize="15px"
                          color='#256EFF'
                          variant="contained"
                          type={"submit"}
                          handleClick={cropUploadedImage}
                        >
                          {t('imageUploadMsgDoneBtn')}
                        </CustomButton>
                      </div>
                    </div>
                  </>

                ))
            }
          </div>
        )}
      </ImageUploading>
    </div>
  );
}